export default __webpack_public_path__ + "static/media/landing_page_hex_3.45e65a0b.png";